export default function (_ref) {
  var _theme$components;

  let {
    theme
  } = _ref;
  let cssRoot = {},
      cssBody = {},
      cssToolsContainer = {},
      cssLogo = {},
      cssLogoLink = {},
      cssSkipLink = {};
  const masthead = theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components.masthead;

  if (masthead) {
    cssRoot = masthead.root;
    cssBody = masthead.body;
    cssToolsContainer = masthead.toolsContainer;
    cssLogo = masthead.logo;
    cssLogoLink = masthead.logoLink;
    cssSkipLink = masthead.skipLink;
  }

  return {
    cssRoot,
    cssBody,
    cssToolsContainer,
    cssLogo,
    cssLogoLink,
    cssSkipLink
  };
}